import clsx from "clsx";
import dayjs from "dayjs";

import { RefreshCcw } from "@hagerty/icons";

import { BillDueProps } from "./BillDue.types";
import styles from "./BillDue.module.scss";

const getDateText = (datePrefixText: string, date?: string): string =>
  date ? `${datePrefixText} ${dayjs(date).format("MMM D, YYYY")}` : "";

export const BillDue = ({
  variant,
  hasError,
  date,
  className,
  style,
}: BillDueProps) => (
  <p
    style={style}
    className={clsx(
      styles.billDue,
      {
        [styles.billDueRecursive]: variant === "recursive",
        [styles.billDueError]: hasError,
      },
      className
    )}
  >
    {variant === "endorsement" && <>One time payment due today</>}
    {variant === "single" && !hasError && <>Due {getDateText("on", date)}</>}
    {variant === "single" && hasError && <>Past due{getDateText(":", date)}</>}
    {variant === "recursive" && (
      <>
        <span>
          {!hasError && <RefreshCcw />}
          Auto Pay {hasError && " failed "}
        </span>
        {getDateText("on", date)}
      </>
    )}
  </p>
);
